module.exports = __webpack_public_path__ + "img/AldhairVeraLogo.724654fd.png";